module.exports = __webpack_public_path__ + "img/report-10.dd53b771.jpg";